import { render, staticRenderFns } from "./SubCollectionsTable.vue?vue&type=template&id=57f885d9&"
import script from "./SubCollectionsTable.vue?vue&type=script&lang=js&"
export * from "./SubCollectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SubCollectionsTable.vue?vue&type=style&index=0&id=57f885d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports